export default __webpack_public_path__ + "static/media/PiramideOpen.919a0bb7.jpg";